  import gnaneswarpic from "../Assets/gnaneswarthavva.jpeg";

  export const profile = {
    name: "Gnaneswar Thavva",
    titles: ["Full Stack Developer", "MERN Stack Developer" ],
    bio: [
      //"I build scalable, high-performance applications using TypeScript, JavaScript, React, Node.js, AWS, and LLM orchestration.",
      //"From crafting intuitive frontends to designing robust APIs, cloud architecture, and intelligent AI workflows, I deliver quality code that drives real impact.",
      //"Passionate about solving complex challenges in fast-paced, collaborative environments. Ready to build something exceptional together",
      "I'm a Computer Science student with a passion for solving complex problems and crafting efficient solutions. I actively participate in competitive programming and enjoy building responsive, user-friendly web applications. With a strong foundation in algorithms and full-stack development, I'm always eager to learn, collaborate, and innovate."
    ],
    image: gnaneswarpic,
    social: {
      email: "thavvagnaneswar675@gmail.com",
      linkedin: "https://www.linkedin.com/in/gnaneswarthavva675/",
      github: "https://github.com/gnaneswar675",
      codechef : "https://www.codechef.com/users/gnaneswar675",
      leetcode : "https://leetcode.com/u/gnaneswarthavva675/",
      codeforces : "https://codeforces.com/profile/gnaneswar_675",
    },
  };
